<template>
    <div class="animated fadeIn">
        <a-modal
            :visible="showSelectUnitModal"
            width="800px"
            :closable="false"
            @ok="closeShowSelectUnitModal"
            @cancel="closeShowSelectUnitModal"
        >
            <UnitDropdown
                @select="onUnitSelected"
                :orgId="$route.params.orgId"
                :select-label="''"
                :deselect-label="''"
                :selected-label="''"
            />
        </a-modal>

        <ResourceTable
            ref="resourceTable"
            resource-name="users/search"
            :query="searchQuery"
            :filter="dataFilter"
            :fields="selectedFields"
            :include="selectedFieldsKeys"
        >
            <Tabs />
            <h1>{{ $t('label.users') }}</h1>

            <!-- FilterRow -->
            <b-row style="margin-bottom: 10px" slot="default">
                <b-col sm="12" md="4">
                    <div style="font-weight: bold">
                        {{ $t('label.chooseFilter') }}
                    </div>

                    <a-button-group>
                        <a-button
                            :key="index"
                            :type="getBtnType(uf.key)"
                            v-for="(uf, index) in visibleUnitFilters"
                            @click="toggleUnitFilter(uf.key)"
                            >{{ uf.label }}</a-button
                        >
                    </a-button-group>
                </b-col>

                <b-col sm="12" md="2">
                    <b>{{ $t('label.filter') }}</b>
                    <a-input-search v-model="searchQuery" />
                </b-col>
                <b-col sm="12" md="3">
                    <div style="font-weight: bold">Felter</div>
                    <a-select
                        :defaultValue="defaultFields"
                        @select="onFieldChange"
                        @deselect="onFieldDeselect"
                        mode="multiple"
                        style="width: 100%"
                    >
                        <a-select-option
                            v-for="field in fields"
                            :key="field.key"
                            >{{ field.label }}</a-select-option
                        >
                    </a-select>
                </b-col>
                <b-col sm="12" md="2">
                    <div>&nbsp;</div>
                    <a-button
                        type="primary"
                        @click="$refs.resourceTable.downloadCollection()"
                    >
                        <i class="fa fa-file-excel-o" />
                        <span>&nbsp; {{ $t('label.exportToExcel') }}</span>
                    </a-button>
                </b-col>
            </b-row>

            <!-- Actions -->
            <!-- Todo: Remove this -->
            <!-- <template slot="actions" slot-scope="row">
                <router-link :to="createUserLink(row.item.data.id)">
                    <a-button
                        size="small"
                        shape="circle"
                        :title="$t('label.goTo')"
                    >
                        <a-icon type="right" />
                    </a-button>
                </router-link>
            </template> -->

            <template
                v-for="(k, index) in ['name', 'firstname', 'lastname']"
                :slot="k"
                slot-scope="row"
            >
                <router-link
                    :to="createUserLink(row.item.data.id)"
                    :key="index"
                    :title="$t('label.goTo')"
                >
                    {{ getValueFromField(row, 'item.data.' + k) }}
                </router-link>
            </template>

            <template slot="email" slot-scope="row">
                <a
                    :href="
                        'mailto:' + getValueFromField(row, 'item.data.email')
                    "
                >
                    {{ getValueFromField(row, 'item.data.email') }}
                </a>
            </template>
        </ResourceTable>
    </div>
</template>
<script>
import UnitDropdown from '@/components/UnitDropdown'
import ResourceTable from '@/components/ResourceTable'

import { mapGetters, mapActions } from 'vuex'
import Tabs from '../__Tabs__'
import Fields from './fields'
import get from 'lodash/get'

const fields = Fields

export default {
    components: {
        ResourceTable,
        UnitDropdown,
        Tabs,
    },

    data() {
        return {
            unitFilterMode: 'ALL',
            showSelectUnitModal: false,
            selectedUnits: [],
            units: [],
            // fields: this.getFields(),
            defaultFields: ['firstname', 'lastname', 'email', 'department'],
            selectedFieldsKeys: [],
            searchQuery: '',
            dataFilter: {
                company_id: this.$route.params.orgId,
                department_id: [],
            },
        }
    },

    created() {
        this.getUnits(this.$route.params.orgId)

        this.selectedFieldsKeys = this.defaultFields

        // Set filtermode to MYUNIT if the current company is the same as
        // the current authenticated user
        if (this.user.company.id == this.$route.params.orgId) {
            this.toggleUnitFilter('MYUNIT')
        }
    },

    methods: {
        ...mapActions({
            getUnits: 'companies/getUnits',
        }),

        getValueFromField(obj, path, def = '') {
            return get(obj, path, def)
        },

        createUserLink(userId) {
            return (
                '/organization/' + this.$route.params.orgId + '/users/' + userId
            )
        },

        onFieldChange(key) {
            this.selectedFieldsKeys.push(key)
        },

        onFieldDeselect(key) {
            let index = this.selectedFields.findIndex(el => el.key == key)
            this.selectedFieldsKeys.splice(index, 1)
        },

        onUnitSelected(unit) {
            // Note: In the future this will be unit_id
            this.dataFilter.department_id = [unit.id]
            this.showSelectUnitModal = false
        },

        closeShowSelectUnitModal() {
            this.showSelectUnitModal = false
        },

        getBtnType(mode) {
            return mode == this.unitFilterMode ? 'primary' : 'default'
        },

        toggleUnitFilter(mode) {
            // console.log('toggleUnitFilter', mode)
            this.unitFilterMode = mode

            switch (mode) {
                case 'SELECTED':
                    this.showSelectUnitModal = true
                    break
                case 'MYUNIT':
                    this.dataFilter.department_id = [this.user.department_id]
                    break
                case 'MANAGING':
                    this.dataFilter.department_id = this.user.manager_unit_accesses.map(
                        u => u.unit_id
                    )
                    break
                default:
                    this.dataFilter.department_id = []
                    break
            }
        },
    },
    computed: {
        fields() {
            return fields.map(field => {
                field['label'] = this.$t(field.label)
                return field
            })
        },

        ...mapGetters({
            user: 'auth/user',
            authIsManager: 'auth/isManager',
            unitsLoading: 'companies/isLoading',
            companies: 'companies/list',
        }),

        selectedFields() {
            return this.selectedFieldsKeys
                .map(k => {
                    return this.fields.filter(f => f.key == k)[0]
                })
                .map(f => {
                    if (!f.path) {
                        f.path = f.key
                    }
                    return f
                })
        },

        visibleUnitFilters() {
            return [
                {
                    key: 'ALL',
                    label: this.$t('label.allUnits'),
                    visible: true,
                },
                {
                    key: 'MANAGING',
                    label: this.$t('label.myUnits'),
                    visible: this.user.manager_unit_accesses.length > 0,
                },
                {
                    key: 'MYUNIT',
                    label: this.$t('label.myUnit'),
                    visible: this.user.company_id == this.$route.params.orgId,
                },
                {
                    key: 'SELECTED',
                    label: this.$t('label.chooseUnit'),
                    visible: true,
                },
            ].filter(u => u.visible)
        },
    },
}
</script>
